import { Expose } from 'class-transformer';
import * as uuid from 'uuid';

import { SnModel } from '@lib/common/models';

export class FsPermission extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public appLabel: string;

  @Expose()
  public codename: string;

  @Expose()
  public name: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
    this.id = uuid.v4();
  }
}
